import { IGigHardwareRequirementOption, IGigLanguageOption } from './../../store/admin/types/types';
import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { AxiosResponse } from 'axios';
import type { IGig, IGigListRequest, IGigCountriesPayload } from '@/store/admin/types/types';

const getGigList = (request: IGigListRequest): ApiResponse => {
  const queryParams = `client=${request.client}&d=true&c=gigLengthId|gigTypeId|`;
  return v3Get(`${routes.backendUrl.gigAdmin.get}?${queryParams}`);
};

const getGigById = (id: number): ApiResponse => v3Get(`${routes.backendUrl.gigAdmin.getById}${id}/detail`);

const getGigHardwareRequirements = (id: string): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.getHardwareRequirements.replace('{gigId}', id)}`);

const getGigLanguages = (id: string): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.getLanguages.replace('{gigId}', id)}`);

const getGigCountriesDetails = (id: string): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.getCountries.replace('{gigId}', id)}`);

const getGigDetail = (gigId: number, countryId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.preview}${gigId}/country/${countryId}/detail`);

const saveGig = async (gig: IGig): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.gigAdmin.create}`, gig);
};

const updateGigDetails = async (gig: IGig): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.gigAdmin.section.gigDetails}`, gig);
};

const updateHardwareRequirements = async (
  gigId: string,
  hardwareRequirementList: IGigHardwareRequirementOption[],
): Promise<AxiosResponse> => {
  return await v3Post(
    `${routes.backendUrl.gigAdmin.section.gigHardwareRequirements.replace('{gigId}', gigId)}`,
    hardwareRequirementList,
  );
};

const updateLanguages = async (gigId: string, languageList: IGigLanguageOption[]): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.gigAdmin.section.gigLanguage.replace('{gigId}', gigId)}`, languageList);
};

const updateCountries = async (gigId: string, countriesList: IGigCountriesPayload[]): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.gigAdmin.section.gigCountries.replace('{gigId}', gigId)}`, countriesList);
};

export const gigAdminApi = {
  getGigList,
  getGigById,
  getGigDetail,
  saveGig,
  updateGigDetails,
  updateHardwareRequirements,
  getGigHardwareRequirements,
  getGigLanguages,
  updateLanguages,
  getGigCountriesDetails,
  updateCountries,
};
